const AddMembersModal = ({showAddMembers,selectedGroup,connectedUsers,membersToAdd,toggleMemberSelection,handleAddMembersSubmit,setShowAddMembers}) => {
  return (
    <>
      {showAddMembers && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden">
            {/* Modal Header */}
            <div className="p-6 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">Add Members</h3>
                  <p className="text-sm text-gray-500 mt-0.5">
                    Add members to <span className="font-medium text-[#0f6abf]">{selectedGroup?.name}</span>
                  </p>
                </div>
              </div>
            </div>

            {/* Modal Content */}
            <div className="p-6">
              <div className="mb-4">
                <p className="text-sm text-gray-600 mb-3">
                  Select members to add to the group
                </p>
                
                {/* Members List */}
                <div className="space-y-2 max-h-[40vh] overflow-y-auto pr-2">
                  {connectedUsers?.filter(c => c?.user_profile).map((connection) => {
                    const user = connection.user_profile;
                    const isSelected = membersToAdd.includes(user?.id);
                    
                    return (
                      <div
                        key={user.id}
                        className={`flex items-center justify-between p-3 rounded-xl border transition-all duration-200 cursor-pointer ${
                          isSelected
                            ? "border-[#0f6abf] bg-[#e8f0f7]/30"
                            : "border-gray-200 hover:bg-gray-50 hover:border-gray-300"
                        }`}
                        onClick={() => toggleMemberSelection(user.id)}
                      >
                        <div className="flex items-center gap-3">
                          <div className="relative">
                            <div className="w-10 h-10 rounded-lg bg-gray-100 overflow-hidden">
                              {user?.profile_picture ? (
                                <img 
                                  src={user?.profile_picture} 
                                  alt={user?.name}
                                  className="w-full h-full object-cover"
                                />
                              ) : (
                                <div className="w-full h-full flex items-center justify-center bg-gray-200">
                                  <span className="text-gray-500 font-medium text-sm">
                                    {(user?.name?.charAt(0) || '').toUpperCase()}
                                  </span>
                                </div>
                              )}
                            </div>
                            <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                          </div>
                          
                          <div>
                            <h4 className="font-medium text-gray-900 text-sm">{user?.name}</h4>
                            <p className="text-xs text-gray-500">Online</p>
                          </div>
                        </div>
                        
                        <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${
                          isSelected
                            ? "border-[#0f6abf] bg-[#0f6abf]"
                            : "border-gray-300"
                        }`}>
                          {isSelected && (
                            <svg className="w-3.5 h-3.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                            </svg>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                
                {/* Selected Count */}
                <div className="mt-4 flex items-center justify-between text-sm">
                  <span className="text-gray-600">
                    {membersToAdd.length} member{membersToAdd.length !== 1 ? 's' : ''} selected
                  </span>
                  {membersToAdd.length > 0 && (
                    <button
                      onClick={() => connectedUsers?.filter(c => c?.user_profile).forEach(c => toggleMemberSelection(c.user_profile.id))}
                      className="text-[#0f6abf] hover:text-[#0a5ca8] font-medium text-sm"
                    >
                      Clear all
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
              <div className="flex items-center justify-end gap-3">
                <button
                  className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
                  onClick={() => setShowAddMembers(false)}
                >
                  Cancel
                </button>
                <button
                  className={`px-5 py-2.5 font-medium rounded-xl transition-colors flex items-center gap-2 min-w-[100px] justify-center ${
                    membersToAdd.length > 0
                      ? "bg-[#0f6abf] text-white hover:bg-[#0a5ca8]"
                      : "bg-gray-200 text-gray-400 cursor-not-allowed"
                  }`}
                  onClick={handleAddMembersSubmit}
                  disabled={membersToAdd.length === 0}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                  </svg>
                  Add Members
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default AddMembersModal
